/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VolumeMini
 */
export interface VolumeMini {
    /**
     * 
     * @type {number}
     * @memberof VolumeMini
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof VolumeMini
     */
    path?: string;
    /**
     * 
     * @type {string}
     * @memberof VolumeMini
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof VolumeMini
     */
    visualTag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VolumeMini
     */
    type?: VolumeMiniTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum VolumeMiniTypeEnum {
    Generic = 'generic',
    GenericMount = 'generic-mount',
    Snfs = 'snfs',
    Btrfs = 'btrfs',
    Lizardfs = 'lizardfs',
    Bcachefs = 'bcachefs',
    Onefs = 'onefs',
    Beegfs = 'beegfs',
    Cloud = 'cloud'
}

export function VolumeMiniFromJSON(json: any): VolumeMini {
    return VolumeMiniFromJSONTyped(json, false);
}

export function VolumeMiniFromJSONTyped(json: any, ignoreDiscriminator: boolean): VolumeMini {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'displayName': !exists(json, 'display_name') ? undefined : json['display_name'],
        'visualTag': !exists(json, 'visual_tag') ? undefined : json['visual_tag'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function VolumeMiniToJSON(value?: VolumeMini | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'path': value.path,
        'display_name': value.displayName,
        'visual_tag': value.visualTag,
        'type': value.type,
    };
}


